export enum cargoReleaseTypes {
  GET_CARGORELEASE = '@@cargoRelease/GET_CARGORELEASE',
  GET_CARGORELEASE_SUCCESS = '@@cargoRelease/GET_CARGORELEASE_SUCCESS',
  GET_CARGORELEASE_FAIL = '@@cargoRelease/GET_CARGORELEASE_FAIL',

  GET_MILESTONESCONFIG_CR = "@CR/GET_MILESTONECONFIG",
  GET_MILESTONESCONFIG_CR_SUCCESSS = "@CR/GET_MILESTONECONFIG_SUCCESS",
  GET_MILESTONESCONFIG_CR_FAIL = "@CR/GET_MILESTONECONFIG_FAIL"
}
